<h1 mat-dialog-title>Delete Template?</h1>
<div mat-dialog-content>
  <p>Do you want to delete "{{templateName}}" template? </p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="dialogRef.close(false)" cdkFocusInitial>Cancel</button>
    <button mat-button (click)="dialogRef.close(true);">Yes</button>
</div>
